<template>
  <div class="vip-center">
    <div class="top"></div>
    <div class="bottom">
      <div
        class="slide-wrap"
        :class="{
          'is-right': slideIndex === 4
        }"
      >
        <ul
          :class="{
            index1: slideIndex === 1,
            index2: slideIndex === 2,
            index3: slideIndex === 3,
            index4: slideIndex === 4
          }"
        >
          <!-- 卡片 -->
          <li
            v-for="n in 4"
            :key="n"
            :class="{
              grade1: n === 1 && level > 0,
              grade2: n === 2,
              grade3: n === 3,
              grade4: n === 4,
              'grade4-privilege': n === 4 && showUserPrivilegePage
            }"
            @click="handleClickCard(n)"
          >
            <!-- 角標 -->
            <div
              v-if="grade <= n"
              class="flag"
              :class="{
                now: grade === n,
                next: grade < n
              }"
            ></div>
            <!-- 有效期 -->
            <!-- <div v-if="grade === n && level > 0" class="effect">
              有效期至{{ effect }}
            </div> -->
            <!-- 會員名稱 -->
            <div class="name">
              {{ level === 0 && n == 1 ? grades[0] : grades[n] }}
              <span v-if="grade === n && level !== 0" class="level">{{
                level
              }}</span>
            </div>
            <!-- 進度 -->
            <div class="percent">
              <dl class="lvs">
                <dd v-for="item in levels[n - 1]" :key="item">
                  {{ item }}
                </dd>
              </dl>
              <div class="stick">
                <span
                  :class="{
                    hidden: grade < n
                  }"
                  :style="{
                    width: grade > n ? '100%' : grade < n ? 0 : percent
                  }"
                >
                </span>
              </div>
            </div>
            <!-- 提醒 -->
            <div class="tips">
              <p v-if="typeof textComputed[n - 1] === 'string'">
                {{ textComputed[n - 1] }}
              </p>
              <dl v-else>
                <dd v-for="(text, index) in textComputed[n - 1]" :key="index">
                  {{ text }}
                </dd>
              </dl>
            </div>
          </li>
        </ul>
        <div v-show="slideIndex > 1" class="button prev" @click="slideIndex--">
          <fps-icon type="arrow-left" :size="24" color="#fff" />
        </div>
        <div v-show="slideIndex < 4" class="button next" @click="slideIndex++">
          <fps-icon type="arrow-right" :size="24" color="#fff" />
        </div>
      </div>
      <div class="rules">
        <div class="tags">
          <button
            :class="{ active: showUserPrivilegePage }"
            @click="showUserPrivilege()"
          >
            {{ $t('upgrade_page_views_vip_center_index_442') }}
          </button>
          <button
            :class="{ active: !showUserPrivilegePage }"
            @click="hiddenUserPrivilege()"
          >
            {{ $t('upgrade_page_views_vip_center_index_443') }}
          </button>
        </div>
        <!-- <div class="title">等級規則</div> -->
        <div
          ref="privilegeBox"
          class="privilege-box"
          v-if="showUserPrivilegePage"
        >
          <div class="level4-privilege-box">
            <div
              class="level4-privilege-item"
              :class="{ status1: userPrivilege.status === 1 }"
            >
              <p>
                {{ userPvivilegeText }}
              </p>
              <button
                class="is-active"
                @click.stop="claimChests"
                v-if="userPrivilege.status === 1"
              >
                {{ $t('upgrade_page_views_vip_center_index_444') }}
              </button>
            </div>
            <div
              class="level4-privilege-item"
              v-if="userPrivilege.status === 1"
            >
              {{
                $t('upgrade_page_views_vip_center_index_475', [
                  userPrivilege.afterAmount,
                  userPrivilege.afterUserLevel
                ])
              }}
            </div>
          </div>
          <div class="content">
            <div v-for="item of privilegeList" :key="item.level">
              <div class="item" v-if="item.list && item.list.length == 1">
                <div class="left">
                  <div class="left-top">
                    <img
                      src="./images/icon-lock.png"
                      alt=""
                      v-if="item.level > userInfo.userLevel"
                    />
                    <img src="./images/icon-check.png" alt="" v-else />
                    <span>{{ item.levelName }}</span>
                  </div>
                  <div class="left-bottom">{{ item.list[0].title }}</div>
                </div>
                <div class="right">
                  <img :src="item.list[0].src" alt="" />
                </div>
              </div>
              <div
                class="item-dropdown"
                v-if="item.list && item.list.length > 1"
              >
                <div class="reward-title">
                  <div class="left">
                    <img
                      src="./images/icon-lock.png"
                      alt=""
                      v-if="item.level > userInfo.userLevel"
                    />
                    <img src="./images/icon-check.png" alt="" v-else />
                    <span> {{ item.levelName }}</span>
                  </div>
                  <!-- <van-icon name="arrow-down" class="right" /> -->
                </div>
                <div class="reward-list">
                  <div
                    class="reward-item"
                    v-for="(content, index) of item.contents"
                    :key="index"
                  >
                    {{ content }}
                    <!-- <img
                      src="./images/icon-info.png"
                      alt=""
                      class="info"
                      v-if="content == '可享免費保級特權'"
                      @click="showRulesInfo('relegationInfoDialog')"
                    /> -->
                    <!-- <img
                      src="./images/icon-info.png"
                      alt=""
                      class="info"
                      v-if="/可指定陪玩師上推薦/.test(content)"
                      @click="showRulesInfo('recommendDialog')"
                    />
                    <img
                      src="./images/icon-info.png"
                      alt=""
                      class="info"
                      v-if="/可指定陪玩師上APP封面/.test(content)"
                      @click="showRulesInfo('appDialog')"
                    /> -->
                  </div>
                </div>

                <div class="detail-box">
                  <div
                    class="detail-item"
                    v-for="(privilege, index) of item.list"
                    :key="index"
                  >
                    <div class="left">
                      <div>{{ privilege.title }}</div>
                      <div v-if="privilege.remark">
                        {{ privilege.remark }}
                      </div>
                    </div>
                    <div class="right">
                      <img :src="privilege.src" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul class="content" v-else>
          <li>
            <p>{{ $t('upgrade_page_views_vip_center_index_448') }}</p>
          </li>
          <li>
            <p>{{ $t('upgrade_page_views_vip_center_index_449') }}</p>
            <p>{{ $t('upgrade_page_views_vip_center_index_450') }}</p>
            <p>{{ $t('upgrade_page_views_vip_center_index_451') }}</p>
          </li>
          <li>
            <p>{{ $t('upgrade_page_views_vip_center_index_452') }}</p>
            <p>{{ $t('upgrade_page_views_vip_center_index_453') }}</p>
          </li>
          <li>
            <p>{{ $t('upgrade_page_views_vip_center_index_454') }}</p>
          </li>
          <li>
            <p>{{ $t('upgrade_page_views_vip_center_index_455') }}</p>
          </li>
          <li>
            <p>{{ $t('upgrade_page_views_vip_center_index_456') }}</p>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog
      class="info-dialog"
      :visible.sync="relegationInfoDialog"
      :title="$t('upgrade_page_views_vip_center_index_457')"
      :modal-append-to-body="false"
      width="30%"
    >
      <p>
        {{ $t('upgrade_page_views_vip_center_index_458') }}<br /><br />{{
          $t('upgrade_page_views_vip_center_index_459', [
            userRelegationPrivilege.count || 0
          ])
        }}<br />{{
          userRelegationPrivilege.count != 2
            ? $t('upgrade_page_views_vip_center_index_476', [
                userRelegationPrivilege.continuousCount || 0
              ])
            : $t('upgrade_page_views_vip_center_index_477')
        }}<br /><br />{{ $t('upgrade_page_views_vip_center_index_461')
        }}<br /><br />{{ $t('upgrade_page_views_vip_center_index_452')
        }}<br />{{ $t('upgrade_page_views_vip_center_index_462') }}
      </p>
    </el-dialog>
    <el-dialog
      class="info-dialog"
      :visible.sync="recommendDialog"
      :title="$t('upgrade_page_views_vip_center_index_463')"
      :modal-append-to-body="false"
      width="30%"
    >
      <p>{{ $t('upgrade_page_views_vip_center_index_464') }}</p>
    </el-dialog>
    <el-dialog
      class="info-dialog"
      :visible.sync="appDialog"
      :title="$t('upgrade_page_views_vip_center_index_465')"
      :modal-append-to-body="false"
      width="30%"
    >
      <p>{{ $t('upgrade_page_views_vip_center_index_466') }}</p>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '@/locales/index';

import { mapGetters } from 'vuex';
import { formatDateYYYYMMDD } from '@/utils/date';
import { getUserPrivilege as getUserPrivilegeList } from '@/filters';
import { Loading } from 'element-ui';

export default {
  data() {
    return {
      levelMax: 15,
      level: 0,
      percent: 0,
      effect: '',
      nextLevelConsume: 0,
      stayLevelConsume: 0,
      slideIndex: 1,
      grades: [
        i18n.t('filters_index_90'),
        i18n.t('filters_index_91'),
        i18n.t('filters_index_92'),
        i18n.t('filters_index_93'),
        i18n.t('filters_index_94')
      ],
      levels: [
        ['VIP0', 'VIP1', 'VIP2', 'VIP3', 'VIP4', 'VIP5'],
        ['VIP6', 'VIP7', 'VIP8', 'VIP9', 'VIP10'],
        ['VIP11', 'VIP12'],
        ['VIP13', 'VIP14', 'VIP15']
      ],
      textStatic: [],
      userPrivilege: {},
      showUserPrivilegePage: true,
      formatDateYYYYMMDD,
      relegationInfoDialog: false,
      recommendDialog: false,
      appDialog: false,
      userRelegationPrivilege: {},
      getUserLevelReceiveLoading: null,
      loadingInstance: null,
      levelInfo: {}
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    grade() {
      return this.level < 6
        ? 1
        : this.level > 10
        ? this.level > 12
          ? 4
          : 3
        : 2;
    },
    textComputed() {
      return this.textStatic.map((item, index) => {
        if (item) {
          return item;
        } else {
          const { level, levelMax, grade } = this;
          const levelNext = Math.min(level + 1, levelMax);
          if (index === 2 && level === levelMax) {
            return '';
          } else {
            const startLevels = [0, 5, 10, 12];
            const nextLevel =
              grade - 1 === index ? levelNext : startLevels[index] + 1;
            const nextLevelConsume =
              grade - 1 === index
                ? this.levelInfo.nextLevelConsume
                : this.levelInfo['grade' + (index + 1)].needConsume;
            const levelName =
              nextLevel === 6
                ? i18n.t('filters_index_92')
                : nextLevel === 11
                ? i18n.t('filters_index_93')
                : nextLevel === 13
                ? i18n.t('filters_index_94')
                : 'VIP' + levelNext;
            const text2 = i18n.t('upgrade_page_views_vip_center_index_478', [
              this.userPrivilege.amount,
              this.ceil(nextLevelConsume),
              levelName
            ]);
            if (level === 15) {
              return i18n.t('upgrade_page_views_vip_center_index_467', [
                this.userPrivilege.amount
              ]);
            }
            return text2;
          }
        }
      });
    },
    privilegeList() {
      return getUserPrivilegeList(this.slideIndex - 1);
    },
    userPvivilegeText() {
      const markUserLevel = 'VIP' + this.userPrivilege.markUserLevel;
      const userLevel = 'VIP' + this.userInfo.userLevel;
      if (this.userPrivilege.status === 1) {
        return i18n.t('upgrade_page_views_vip_center_index_468', [
          markUserLevel
        ]);
      } else if (this.userPrivilege.status === 2) {
        return `
          ${
            this.levelInfo.userLevel > 3
              ? i18n.t('upgrade_page_views_vip_center_index_469', [
                  userLevel,
                  userLevel
                ])
              : i18n.t('upgrade_page_views_vip_center_index_470', [userLevel])
          } `;
      } else {
        return `
          ${
            this.levelInfo.userLevel > 3
              ? i18n.t('upgrade_page_views_vip_center_index_469', [
                  userLevel,
                  userLevel
                ])
              : i18n.t('upgrade_page_views_vip_center_index_470', [userLevel])
          } `;
      }
    }
  },
  methods: {
    setLoading(message) {
      const text = message;
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: text,
        background: 'rgba(0, 0, 0, 0.7)',
        spinner: 'el-icon-loading',
        lock: true
      });
    },
    // 关闭loading状态
    closeLoading() {
      this.loadingInstance.close();
    },
    // 獲取用戶權益
    getUserPrivilege() {
      this.$http.get('/userPrivilege/queryLevelReceive').then(({ data }) => {
        this.userPrivilege = data;
      });
    },
    // 獲取用戶保级權益
    getUserRelegationPrivilege() {
      this.$http
        .get('/userPrivilege/query')
        .then(({ data }) => {
          this.userRelegationPrivilege = data || {};
        })
        .catch(err => {
          console.log(err);
        });
    },
    showUserPrivilege() {
      this.showUserPrivilegePage = true;
    },
    hiddenUserPrivilege() {
      this.showUserPrivilegePage = false;
    },
    // 領取獎勵
    claimChests() {
      if (this.getUserLevelReceiveLoading) return;
      if (this.userPrivilege.status === 1) {
        this.$confirm({
          title: i18n.t('upgrade_page_views_vip_center_index_471'),
          content: i18n.t('upgrade_page_views_vip_center_index_479', [
            this.userPrivilege.afterUserLevel
          ]),
          confirmButtonText: i18n.t('upgrade_page_views_vip_center_index_444'),
          cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
          showCancelButton: true,
          confirmButtonClass: 'vip-center-confirm'
        }).then(() => {
          this.getUserLevelReceive(false);
        });
      }
    },

    getUserLevelReceive(applyRetention) {
      this.getUserLevelReceiveLoading = true;
      this.setLoading(i18n.t('upgrade_page_views_vip_center_index_472'));
      this.$http
        .post('/userPrivilege/getUserLevelReceive', {
          applyRetention: !!applyRetention
        })
        .then(() => {
          this.$confirm({
            content: i18n.t('upgrade_page_views_vip_center_index_473', [
              this.userPrivilege.afterUserLevel
            ]),
            confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
            showCancelButton: false
          });
          this.init();
        })
        .finally(() => {
          this.getUserLevelReceiveLoading = false;
          this.closeLoading();
        });
    },

    handleClickCard(index) {
      if (index === 4 && this.showUserPrivilege) {
        this.hiddenUserPrivilege();
      }
    },
    showRulesInfo(dialogType) {
      if (dialogType == 'relegationInfoDialog') {
        this.relegationInfoDialog = true;
      } else if (dialogType == 'recommendDialog') {
        this.recommendDialog = true;
      } else {
        this.appDialog = true;
      }
    },
    hiddenRelegationInfo() {
      this.relegationInfoDialog = false;
    },
    ceil(num) {
      return num ? Math.ceil(num) : 0;
    },
    init() {
      this.level = this.userInfo.userLevel || 0;
      this.$http.get('/user/level').then(({ data }) => {
        const {
          levelDetail,
          effectTimeTo,
          nextLevelConsume,
          stayLevelConsume
          // userLevel
        } = data;
        this.levelInfo = data;
        // if (userLevel > 12) {
        //   this.getUserRelegationPrivilege();
        // }
        const ary = (levelDetail + '').split('.');
        const level = +ary[0];
        if (this.level !== level) {
          // 更新userInfo中的level
          this.$store.dispatch('app/setSomeUserInfo', { userLevel: level });
        }
        this.level = level;
        this.effect = new Date(effectTimeTo).$format('yyyy.MM.dd');
        this.nextLevelConsume = nextLevelConsume;
        this.stayLevelConsume = stayLevelConsume;
        this.$nextTick(() => {
          const { grade, level, levels, levelMax } = this;
          let per = (ary[1] || '0').substring(0, 2);
          per = level >= levelMax ? 0 : +('.' + per);
          if (level === 5 || level === 10 || level === 12) {
            per = 0;
          }
          const cells = levels[grade - 1].length - 1;
          const cell = 1 / cells;
          const lv =
            grade === 1
              ? level
              : grade === 2
              ? level - 6
              : grade === 3
              ? level - 11
              : level - 13;
          this.percent = (lv / cells + cell * per) * 100 + '%';
          this.slideIndex = grade;
          this.textStatic = [
            grade > 1 ? i18n.t('upgrade_page_views_vip_center_index_474') : '',
            grade > 2 ? i18n.t('upgrade_page_views_vip_center_index_474') : '',
            grade > 3 ? i18n.t('upgrade_page_views_vip_center_index_474') : '',
            ''
          ];
        });
        // }, 800)
      });
      this.getUserPrivilege();
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
// 除法函數
@function divideBy($number) {
  @return $number / 1.6;
}
$color-gold: #f0bb97;

.vip-center {
  @include flex(flex-start, stretch, column);
  position: relative;
  overflow: hidden;
  background-color: #232c43;
  .top {
    flex-shrink: 0;
    position: relative;
    width: 100%;
    height: 248px;
  }
  .bottom {
    @include flex(flex-start, stretch, column);
    flex-grow: 1;
    position: relative;
    // 左右斜線條
    &::before,
    &::after {
      content: '';
      position: absolute;
      z-index: 2;
      width: 1920px;
      height: 80px;
      top: 0;
      background-color: #454b60;
      border-top: 2px solid $color-gold;
    }
    &::before {
      right: 50%;
      transform: rotate(4.67deg);
    }
    &::after {
      left: 50%;
      transform: rotate(-4.67deg);
    }
    .slide-wrap {
      flex-shrink: 0;
      position: relative;
      z-index: 1;
      width: 2190px;
      height: 256px;
      margin-top: -224px;
      margin-left: 50%;
      transform: translateX(-50%);
      // 左右陰影
      &::before,
      &::after {
        content: '';
        position: absolute;
        z-index: 1;
        left: 50%;
        top: 0;
        width: 677px;
        height: 100%;
        background: linear-gradient(
          90deg,
          #232c43 33.46%,
          rgba(35, 44, 67, 0) 100%
        );
        pointer-events: none;
      }
      &::before {
        // margin-left: -960px;
        margin-left: -1360px;
      }
      &::after {
        // margin-left: 283px;
        margin-left: 583px;
        transform: matrix(-1, 0, 0, 1, 0, 0);
      }
      &.is-right {
        &::after {
          opacity: 0.1;
        }
      }
      ul {
        position: relative;
        width: 100%;
        height: 100%;
        transition: transform 0.3s;
        &.index1 {
          transform: translateX(828px);
        }
        &.index2 {
          transform: translateX(278px);
        }
        &.index3 {
          transform: translateX(-272px);
        }
        &.index4 {
          transform: translateX(-822px);
        }
        li {
          @include flex(flex-end, flex-start, column);
          position: relative;
          z-index: 0;
          float: left;
          width: 534px;
          height: 100%;
          padding: 30px 60px 45px;
          border-radius: 40px;
          box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1),
            0px 2px 8px rgba(0, 0, 0, 0.16);
          background: #eff3fa;
          color: #535c65;
          // 黃金
          &.grade1 {
            background: linear-gradient(102.94deg, #f5e4c5 0%, #e3bf80 100%);
            color: #63481b;
            .flag {
              &.now {
                background: #63481b;
                color: #f4e4c7;
                border-bottom-color: #63481b;
                &::before {
                  @include triangle(16px, #63481b, bottom, 0.41);
                }
              }
            }
            .level {
              background-color: #63481b;
            }
            .stick {
              background-color: #c29f61;
              span {
                background-color: #63481b;
              }
            }
          }
          // 鑽石
          &.grade2 {
            background: linear-gradient(
              102.94deg,
              #feecf5 0%,
              #c5dff9 27.08%,
              #eaf5ff 54.17%,
              #dbedfc 84.38%,
              #eae2ff 100%
            );
            color: $color-gray-1;
            .flag {
              &.now {
                background: linear-gradient(180deg, #423e57 0%, #2c2942 100%);
                color: #fff;
                border-bottom-color: #2c2942;
                &::before {
                  @include triangle(16px, #2c2942, bottom, 0.41);
                }
              }
              &.next {
                background-color: #2c2942;
                color: #fff;
              }
            }
            .level {
              background-color: #2c2942;
            }
            .stick {
              background-color: #b3d8fe;
              span {
                background-color: #2c2942;
              }
            }
          }
          // 黑金
          &.grade3 {
            background: linear-gradient(102.94deg, #2c231d 0%, #202020 100%);
            color: $color-gold;
            border: 1px solid $color-gold;
            .flag {
              &.now {
                background: linear-gradient(180deg, #ffd0b0 0%, #f0bb97 100%);
                color: #10100f;
                border-bottom-color: #f0bb97;
                &::before {
                  @include triangle(16px, #f0bb97, bottom, 0.41);
                }
              }
              &.next {
                background-color: #f0bb97;
                color: #10100f;
              }
            }
            .level {
              background-color: $color-gold;
              color: #10100f;
            }
            .stick {
              background-color: #573f2f;
              span {
                background-color: $color-gold;
              }
            }
          }
          &.grade4 {
            background: url('./images/level4.png') no-repeat center top;
            background-size: 100% auto;
            color: #ffeed0;
            border: 1px solid $color-gold;
            .flag {
              &.now {
                background: linear-gradient(180deg, #ffd0b0 0%, #f0bb97 100%);
                color: #10100f;
                border-bottom-color: #f0bb97;
                &::before {
                  @include triangle(16px, #f0bb97, bottom, 0.41);
                }
              }
              &.next {
                background-color: #f0bb97;
                color: #10100f;
              }
            }
            .level {
              // background-color: $color-gold;
              // color: #10100f;
              background: #f4c09d;
              color: #4f5467;
              background: url('./images/level-bg.png') no-repeat center top;
              background-size: 100% auto;
              width: 72px;
              height: 45px;
              font-size: 16px;
              line-height: 45px;
            }
            .stick {
              background-color: #626684;
              span {
                background-color: #f0bb97;
              }
            }
          }
          + li {
            margin-left: 16px;
          }
          .flag {
            position: absolute;
            font-size: 14px;
            line-height: 20px;
            &.now {
              box-sizing: content-box;
              right: 60px;
              top: 0;
              width: 78px;
              height: 42px;
              line-height: 44px;
              text-align: center;
              background: #a1aab4;
              color: #eff3fa;
              font-weight: 500;
              border-bottom-width: 2px;
              border-bottom-style: solid;
              border-bottom-color: #a1aab4;
              border-radius: 0 0 3px 3px;
              &::before {
                content: '';
                position: absolute;
                left: 0;
                bottom: -17px;
                width: 100%;
                height: 0;
                @include triangle(16px, #a1aab4, bottom, 0.41);
              }
              &::after {
                position: absolute;
                left: 50%;
                top: 50%;
                line-height: 1.1;
                transform: translate(-50%, -50%);
                content: 'current level';
              }
            }
            &.next {
              left: 0;
              top: 0;
              width: 61px;
              height: 61px;
              line-height: 61px;
              text-align: center;
              border-radius: 36px 0 30.5px 0;
              &::after {
                position: absolute;
                left: 50%;
                top: 50%;
                line-height: 1.1;
                transform: translate(-50%, -50%);
                content: 'awaiting upgrade';
              }
            }
          }
          .effect {
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 34px;
          }
          .name {
            @include flex(flex-start);
            height: 45px;
            font-weight: 600;
            font-size: 32px;
            &.level4-name {
              display: flex;
              justify-content: space-between;
              width: 100%;
              .left {
                @include flex(flex-start);
              }
              .right {
                width: 100px;
                height: 40px;
                border-radius: 100px;
                box-sizing: border-box;
                background: rgba(46, 49, 79, 1);
                font-size: 18px;
                color: #ffeed0;
                font-weight: bold;
              }
            }
          }
          .level {
            display: block;
            margin-left: 8px;
            color: #fff;
            width: 36px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            border-radius: 18px;
            font-size: 24px;
            font-weight: normal;
          }
          .percent {
            width: 100%;
            padding: 16px 0 8px;
            .lvs {
              @include flex(space-between);
              padding-bottom: 2px;
              font-size: 14px;
              line-height: 20px;
            }
          }
          .stick {
            width: 100%;
            height: 16px;
            padding: 1px;
            background-color: #d8dde1;
            border-radius: 32px;
            span {
              display: block;
              width: 0;
              min-width: 14px;
              height: 14px;
              border-radius: 7px;
              background-color: #535c65;
              transition: width 1s;
              &.hidden {
                display: none;
              }
            }
          }
          .tips {
            position: relative;
            overflow: hidden;
            font-size: 14px;
            height: 20px;
            line-height: 20px;
            dl {
              animation: rollup 10s ease-in-out;
              animation-iteration-count: infinite;
            }
          }
        }
      }
      // 切換箭頭
      .button {
        @include flex;
        position: absolute;
        z-index: 2;
        left: 50%;
        top: 50%;
        margin-top: -22px;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.2);
        cursor: pointer;
        &:hover {
          background-color: rgba(0, 0, 0, 0.3);
        }
        &.prev {
          margin-left: -572px;
        }
        &.next {
          margin-left: 528px;
        }
      }
    }
    .rules {
      flex-grow: 1;
      position: relative;
      z-index: 3;
      margin-top: 48px;
      padding-top: 24px;
      background-color: #454b60;
      .title {
        position: relative;
        text-align: center;
        color: #fff;
        font-weight: 500;
        font-size: 16px;
        height: 22px;
        line-height: 22px;
        &::after {
          content: '';
          position: absolute;
          z-index: -1;
          width: 72px;
          height: 7px;
          background-color: $color-gold;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
        }
      }
      .content {
        width: 100%;
        max-width: 1000px;
        transform: translateX(50px);
        margin: 16px auto 0;
        padding-bottom: 100px;
        list-style: decimal outside;
        font-size: 14px;
        color: $color-split;
        &.privilege {
          list-style: none;
        }
        p {
          margin-top: 4px;
          line-height: 24px;
        }
      }
      .tags {
        margin-bottom: divideBy(18px);
        width: 100%;
        max-width: 1000px;
        margin: divideBy(16px) auto 0;
        transform: translateX(50px);

        button {
          padding: divideBy(12px) divideBy(24px);
          border-radius: divideBy(16px);
          opacity: 0.6;
          color: white;
          font-size: divideBy(24px);
          background-color: #c8c8c8;
          &.active {
            opacity: 1;
            background-color: rgba(255, 255, 255, 0.2);
          }
          margin-right: divideBy(24px);
        }
      }
      .privilege-box {
        line-height: 1.8;
        .level4-privilege-box {
          padding-top: 4px;
          margin-bottom: divideBy(18px);
          width: 100%;
          max-width: 1000px;
          margin: divideBy(16px) auto 0;
          transform: translateX(50px);
          .level4-privilege-item {
            color: #ffeed0;

            line-height: 1.2;
            display: flex;
            align-items: center;
            // justify-content: space-between;
            width: 100%;
            margin-top: 6px;
            color: rgba(107, 114, 150, 1);
            &.status1 {
              color: #ffeed0;
            }
            button {
              margin-left: 40px;
              width: 100px;
              text-align: center;
              // border-radius: 80px;
              background: rgba(41, 46, 75, 1);
              padding: 6px 16px;
              color: rgba(107, 114, 150, 1);
              border-radius: 80px;
              &.is-active {
                color: rgba(55, 57, 88, 1);
                background: #ffefd4;
                font-weight: bold;
              }
            }
          }
        }

        .privilege-title {
          padding-top: divideBy(14px);
          font-size: divideBy(30px);
        }
        .progress {
          font-size: divideBy(24px);
          opacity: 0.7;
          margin-bottom: divideBy(24px);
        }
        .content {
          .item {
            height: divideBy(152px);
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;
            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0.2) 0%,
              rgba(255, 255, 255, 0.05) 100%
            );
            border-radius: divideBy(30px);
            padding-left: divideBy(24px);
            margin-bottom: divideBy(18px);
            font-size: divideBy(30px);
            padding-right: divideBy(48px);
            .left {
              .left-top {
                font-size: divideBy(30px);

                img {
                  width: divideBy(28px);
                  height: auto;
                  margin-right: divideBy(16px);
                }
              }
            }
          }
          .left-bottom {
            color: rgba(255, 255, 255, 0.4);
            font-size: divideBy(20px);
            margin-left: divideBy(44px);
          }
        }
        // .right {
        //   width: 128px;
        //   height: auto;
        //   margin-right: 12px;
        // }
        .right {
          flex: none;
          width: divideBy(128px);
          height: divideBy(128px);
          display: flex;
          align-items: center;
          justify-content: center;
          background: url('./images/reward-bg.png') no-repeat center center;
          background-size: 100% 100%;
          margin-right: divideBy(12px);
          img {
            width: divideBy(96px);
          }
        }

        .item-dropdown {
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.2) 0%,
            rgba(255, 255, 255, 0.05) 100%
          );
          border-radius: divideBy(30px);
          padding: divideBy(32px) divideBy(48px) divideBy(24px) divideBy(24px);
          margin-bottom: divideBy(18px);
          .reward-title {
            font-size: divideBy(30px);
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
              width: divideBy(28px);
              height: auto;
              margin-right: divideBy(16px);
            }
          }
          .reward-list {
            margin-bottom: divideBy(32px);
            .reward-item {
              padding-left: divideBy(44px);
              color: rgba(255, 255, 255, 0.4);
              font-size: divideBy(20px);
              display: flex;
              align-items: center;
              .info {
                width: divideBy(28px);
                height: auto;
                margin-left: divideBy(4px);
              }
            }
          }

          .detail-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: divideBy(44px);
            margin-bottom: divideBy(16px);
            height: divideBy(153px);
            border-radius: divideBy(30px);
            background: linear-gradient(
              270deg,
              rgba(255, 255, 255, 0.1) 0%,
              rgba(255, 255, 255, 0.01) 100%
            );
            .right {
              flex: none;
              width: divideBy(128px);
              height: divideBy(128px);
              display: flex;
              align-items: center;
              justify-content: center;
              background: url('./images/reward-bg.png') no-repeat center center;
              background-size: 100% 100%;
              margin-right: divideBy(12px);
            }
            img {
              width: divideBy(96px);
            }
            .left {
              > div {
                color: rgba(255, 255, 255, 0.4);
                font-size: divideBy(20px);
                &:first-child {
                  font-size: divideBy(26px);
                  color: white;
                }
              }
            }
          }
        }
      }
    }
  }
}

@keyframes rollup {
  0% {
    transform: translateY(0);
  }
  5% {
    transform: translateY(-20px);
  }
  50% {
    transform: translateY(-20px);
  }
  55% {
    transform: translateY(-40px);
  }
  100% {
    transform: translateY(-40px);
  }
}
</style>
<style lang="scss">
.info-dialog {
  line-height: 24px;
}
// .info-dialog {
//   .el-dialog {
//     width: 500px !important;
//     height: auto;
//   }
//   .el-dialog__header {
//     display: none;
//   }
//   .el-dialog__body {
//     padding: 0 !important;
//     height: 300px;
//     // width: auto;
//     img {
//       width: 500px;
//     }
//   }
// }
</style>
